import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import {
  TGroupChatGetChannelRequest,
  TGroupChatGetChannelResponse,
} from "../../api/group_chat/get_channel";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";

export type TApiGroupChatGetChannelResult = {
  result?: TGroupChatGetChannelResponse;
};

export const fetchGroupChatGetChannel = async (
  params: TGroupChatGetChannelRequest,
): Promise<TApiResult & TApiGroupChatGetChannelResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;

  return await client()
    .group_chat.get_channel.post({
      body: params,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      if (res.body.status_code !== 0) {
        return {
          isSuccess: false,
          status: res.body.status_code,
          message: "",
        };
      }
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(
        e,
        "fetchGroupChatGetChannel",
      );
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
